import { data } from "react-router-dom";
import { notifyError } from "../components/Toast";

export const SendPaymentData = (data) => {
  return async (dispatch) => {
    dispatch({ type: 'SEND_PAYMENT_DATA_REQUEST' });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/checkout/worldPay/data`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        dispatch({
          type: 'SEND_PAYMENT_DATA_SUCCESS',
          payload: responseData
        });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: 'SEND_PAYMENT_DATA_FAIL', payload: errorMessage });
        notifyError('Hubo un error al procesar el pago');
      }
    } catch (error) {
      dispatch({ type: 'SEND_PAYMENT_DATA_FAIL', payload: error.message });
      notifyError('Error de conexión al procesar el pago');
    }
  };
}; 

export const SendPaymentDataCuotas = (data) => {
  return async (dispatch) => {
    dispatch({ type: 'SEND_PAYMENT_CUOTAS_DATA_REQUEST' });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/checkout/worldPay/data/cuotes`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        dispatch({
          type: 'SEND_PAYMENT_CUOTAS_DATA_SUCCESS',
          payload: responseData
        });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: 'SEND_PAYMENT_CUOTAS_DATA_FAIL', payload: errorMessage });
        notifyError('Hubo un error al procesar el pago');
      }
    } catch (error) {
      dispatch({ type: 'SEND_PAYMENT_CUOTAS_DATA_FAIL', payload: error.message });
      notifyError('Error de conexión al procesar el pago');
    }
  };
}; 

export const GetUserData = (data, _retried = false) => {
  return async (dispatch) => {
    dispatch({ type: 'GET_USER_DATA_REQUEST' });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/checkout/user/data`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data) 
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        dispatch({
          type: 'GET_USER_DATA_SUCCESS',
          payload: responseData
        });
        dispatch(GetProgramaDescripcion(responseData.programa, responseData.entidad || 'UAI'));
      } else {
        // Fallback: alternar espacios y '+' por si el querystring fue decodificado distinto
        if (!_retried && typeof data === 'string') {
          const toggled = data.includes('+') ? data.replace(/\+/g, ' ') : data.replace(/ /g, '+');
          return dispatch(GetUserData(toggled, true));
        }
        const errorMessage = await response.text();
        dispatch({ type: 'GET_USER_DATA_FAIL', payload: errorMessage });
        notifyError('Hubo un error al obtener los datos del usuario');
      }
    } catch (error) {
      dispatch({ type: 'GET_USER_DATA_FAIL', payload: error.message });
      notifyError('Error de conexión al obtener los datos del usuario');
    }
  };
};

export const GetProgramaDescripcion = (programa, entidad = 'UAI') => {
  return async (dispatch) => {
    dispatch({ type: 'GET_PROGRAMA_DESCRIPCION_REQUEST' });

    const dataprogram = programa.split("-")[0];
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/checkout/programa/descripcion?programa=${encodeURIComponent(dataprogram)}&entidad=${encodeURIComponent(entidad)}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        dispatch({
          type: 'GET_PROGRAMA_DESCRIPCION_SUCCESS',
          payload: responseData
        });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: 'GET_PROGRAMA_DESCRIPCION_FAIL', payload: errorMessage });
        notifyError('Hubo un error al obtener la descripción del programa');
      }
    } catch (error) {
      dispatch({ type: 'GET_PROGRAMA_DESCRIPCION_FAIL', payload: error.message });
      notifyError('Error de conexión al obtener la descripción del programa');
    }
  };
};

// Mercado Pago - crear preferencia para carreras
// entidad: la del link de pago (viene en el blob cifrado, la devuelve /user/data). Decide la cuenta
// de MP y la base donde el webhook descarga el pago; NBAPI ya resuelve todo por entidadId (T-2026-111).
export const CreateMPPreference = (payload, entidad = 'UAI') => {
  return async (dispatch) => {
    dispatch({ type: 'MP_CREATE_PREFERENCE_REQUEST' });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/mpuai/pago?entidadId=${encodeURIComponent(entidad)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload)
        }
      );

      if (response.ok) {
        const preferenceId = await response.json();
        dispatch({
          type: 'MP_CREATE_PREFERENCE_SUCCESS',
          payload: preferenceId
        });
      } else {
        const errorMessage = await response.text();
        dispatch({ type: 'MP_CREATE_PREFERENCE_FAIL', payload: errorMessage });
        notifyError('Hubo un error al iniciar Mercado Pago');
      }
    } catch (error) {
      dispatch({ type: 'MP_CREATE_PREFERENCE_FAIL', payload: error.message });
      notifyError('Error de conexión al iniciar Mercado Pago');
    }
  };
};